import { schema, types } from 'papr'
import { WEBHOOK_EVENT } from './webhook-config'

export const webhookMessageSchema = schema({
	webhook: types.objectId({ required: true }),
	publication: types.objectId({ required: true }),
	url: types.string({ required: true }),
	event: types.enum(WEBHOOK_EVENT, { required: true }),
	isTest: types.boolean({ required: true }),
	isResent: types.boolean({ required: true }),
	request: types.object(
		{
			uuid: types.string({ required: true }),
			headers: types.string({ required: true }),
			body: types.string({ required: true }),
			error: types.object({
				code: types.string({ required: true }),
				message: types.string({ required: true }),
			}),
		},
		{ required: true },
	),
	response: types.object({
		httpStatus: types.number({ required: true }),
		headers: types.string(),
		body: types.string(),
		timeToFirstByteMs: types.number(),
	}),
	dateAdded: types.date({ required: true }),
})

export type WebhookMessageDocument = (typeof webhookMessageSchema)[0]
export type WebhookMessageSchemaOptions = (typeof webhookMessageSchema)[1]
